module.exports = __webpack_public_path__ + "static/img/image_j_orange.cf7eb55.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_j_orange.jpg
// module id = 3XX1
// module chunks = 1